import React from 'react';
import { motion } from 'framer-motion';
import { Skull, TreePine, Mountain, Waves, Snowflake, Eye } from 'lucide-react';
import '../styles/ZonesSection.css';

const zones = [
  {
    id: 'zone2',
    name: '盜賊營地',
    level: '4-6',
    icon: <Skull />,
    color: '#ff9900',
    boss: '盜賊首領',
  },
  {
    id: 'zone3',
    name: '焦陽村落',
    level: '7-9',
    icon: <Mountain />,
    color: '#FFD700',
    boss: '沙塵精靈',
  },
  {
    id: 'zone4',
    name: '黃沙陵墓',
    level: '10-12',
    icon: <Eye />,
    color: '#BF9E3B',
    boss: '黃金咒靈 薩塔赫',
  },
  {
    id: 'zone12',
    name: '夢幻蘑菇島',
    level: '34-36',
    icon: <TreePine />,
    color: '#d397f5',
    boss: '菇岩守護者',
  },
  {
    id: 'zone13',
    name: '異蕈浮城',
    level: '37-39',
    icon: <Waves />,
    color: '#d981c2',
    boss: '蕈空浮城主・闇蟲女王',
  },
  {
    id: 'zone14',
    name: '極寒冰原',
    level: '40-42',
    icon: <Snowflake />,
    color: '#5aa6ff',
    boss: '凜冬蛛皇',
  }
];

const ZonesSection: React.FC = () => {
  return (
    <section className="zones" id="zones">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">冒險區域</h2>
          <p className="section-subtitle">
            探索多樣化的世界，每個區域都有獨特的挑戰與獎勵等著你
          </p>
        </motion.div>

        <div className="zones-grid">
          {zones.map((zone, index) => (
            <motion.div
              key={zone.id}
              className="zone-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ y: -10 }}
              style={{ '--zone-color': zone.color } as React.CSSProperties}
            >
              <div className="zone-header">
                <div className="zone-icon" style={{ color: zone.color }}>
                  {zone.icon}
                </div>
                <div className="zone-info">
                  <h3 className="zone-name">{zone.name}</h3>
                  <span className="zone-level">Lv. {zone.level}</span>
                </div>
              </div>
              
              {/* Zone Image Placeholder */}
              <div className="zone-image-container">
                <img 
                  src={`/images/zones/${zone.id}.png`}
                  alt={`${zone.name} 區域截圖`}
                  className="zone-image"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.style.display = 'none';
                    target.nextElementSibling?.classList.remove('hidden');
                  }}
                />
                <div className="zone-placeholder hidden">
                  <div className="placeholder-icon" style={{ color: zone.color }}>
                    {zone.icon}
                  </div>
                  <span>區域截圖佔位符</span>
                </div>
              </div>
              
              <div className="zone-content">
                <div className="boss-info">
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ZonesSection;
